// extracted by mini-css-extract-plugin
export var copyableField = "_k9-4";
export var customerBadge = "_k9-0";
export var customerInfoTitle = "_k9-2";
export var details = "_k9-1";
export var dropdownContainer = "_k9-5";
export var dropdownImage = "_k9-6";
export var editAssigneeForm = "_k9-a";
export var editButton = "_k9-3";
export var email = "_k9-7";
export var hidden = "_k9-d";
export var input = "_k9-8";
export var saveButton = "_k9-b";
export var shopifyIcon = "_k9-c";
export var suggestionBadge = "_k9-e";
export var suggestionText = "_k9-f";
export var username = "_k9-9";